import React from 'react';
import moment from 'moment';
import { i18n } from '../../common/services/globalize';

const formatDate = (data) => {
	if (data) {
		// parse ISO string
		if (moment(data).isValid()) {
			return moment(data).format('L');
		}
		else {
			return data;
		}
	}

	return '';
};

const formatDateTime = (data) => {
	if (data) {
		if (moment(data).isValid()) {
			return moment(data).format('L HH:mm');
		}
		else {
			return data;
		}
	}
	return '';
};

const formatBoolean = (value) => (value ? i18n.t('Common_Yes') : i18n.t('Common_No'));

const makeOptionValues = (entity) => {
	let options;
	const entityArray = Object.values(entity);
	if (entityArray.length > 0) {
		options = entityArray.map(item => <option value={item.id}>{item.displayName ? item.displayName : item.name}</option>);
	}
	return options;
};

const getAvatarName = (firstName, lastName) => {
	if (!firstName && !lastName) {
		return '';
	}

	if (firstName && !lastName) {
		return firstName.substr(0, 2).toUpperCase();
	}

	return (firstName[0] + lastName[0]).toUpperCase();
};

const days = {
	'0': 'WeekDayType_Sunday',
	'1': 'WeekDayType_Monday',
	'2': 'WeekDayType_Tuesday',
	'3': 'WeekDayType_Wednesday',
	'4': 'WeekDayType_Thursday',
	'5': 'WeekDayType_Friday',
	'6': 'WeekDayType_Saturday',
	'7': 'WeekDayType_Sunday'
};

const getWeekdayLabel = (dayNumber) => {
	return i18n.t(days[dayNumber])
}

const formatTime = (date, format) => {
	if (date) {
		format = format || 'LT';

		const momentDate = moment(date);
		if (momentDate.isValid()) {
			return momentDate.format(format);
		}
		else {
			// check if passed value is TimeSpan without date
			const dateWithTime = moment(moment().format('YYYY-MM-DDT') + date);
			if (dateWithTime.isValid()) {
				return dateWithTime.format(format);
			} else {
				return date;
			}
		}
	}
	return '';
};

const getCurrencyConversionLink = (enableCurrencyConversion, currentCurrency, franchisorCurrency, amount) => {
	return enableCurrencyConversion && currentCurrency &&
		franchisorCurrency && currentCurrency !== franchisorCurrency && amount > 0 &&
		`https://www.google.com/search?q=${amount}+${franchisorCurrency}+to+${currentCurrency}`;
}

const getLocaleDateFormat = () => moment.localeData().longDateFormat('L');

// Day and month only, in the order of the current locale (DD/MM for en-GB, MM/DD for en-US, DD.MM for de-DE).
// Derived from the locale's short date format by dropping the year token and one adjacent separator.
const formatDayMonth = (data) => {
	if (!data) {
		return '';
	}

	const date = moment(data);
	if (!date.isValid()) {
		return data;
	}

	const dayMonthFormat = getLocaleDateFormat().replace(/[^DMY]*Y+[^DMY]*/, '');

	return date.format(dayMonthFormat || 'DD/MM');
};

export default {
	days,
	formatDate,
	formatDateTime,
	formatDayMonth,
	formatTime,
	formatBoolean,
	makeOptionValues,
	getAvatarName,
	isMobileView: window.innerWidth < 768,
	getWeekdayLabel,
	getCurrencyConversionLink,
	getLocaleDateFormat
};